<template>
  <PropertyDetailsCardRows>
    <PropertyDetailsCardInfoItem
      v-if="possibleLeaseTerms"
      label="Desired lease term"
      icon="hourglass-03"
      :value="possibleLeaseTerms"
    />

    <PropertyDetailsCardInfoItem
      v-if="desiredLeasingDate"
      label="Available move-in date"
      icon="calendar-check-01"
      :value="desiredLeasingDate"
    />
  </PropertyDetailsCardRows>
</template>

<script setup lang="ts">
import { format, parseISO } from 'date-fns';
import { computed } from 'vue';

import { PropertyDto } from '../../model/property';
import PropertyDetailsCardInfoItem from './property-details-card/property-details-card-info-item.vue';
import PropertyDetailsCardRows from './property-details-card/property-details-card-rows.vue';

const props = defineProps<{
  property: PropertyDto | null | undefined;
}>();

const possibleLeaseTerms = computed(() => props.property?.leaseConditions?.possibleLeaseTerms?.join(', '));
const desiredLeasingDate = computed(() => {
  if (props.property?.leaseConditions?.desiredLeasingDate) {
    const leasingDateAsJsDate = parseISO(props.property?.leaseConditions?.desiredLeasingDate!);

    // removes timezone adjustment, so that the date is the same everywhere
    const dateWithoutTimezoneAdjustment = new Date(
      leasingDateAsJsDate.getTime() + leasingDateAsJsDate.getTimezoneOffset() * 60000,
    );

    return format(dateWithoutTimezoneAdjustment, 'MMMM d, yyyy');
  }

  return '';
});
</script>
